/* eslint-disable import/no-anonymous-default-export */
export default {
  head: "سجل النشاطات",
  activity: "النشاط",
  userTitle: "اسم المستخدم",
  companyTitle: "اسم الشركة",
  dateTimeTitle: "التاريخ و الوقت",
  activityTitle: "اسم النشاط",
};
